import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { AdministratorService } from '../../../services/administrator.service';
import { GSTInfo, gridPageRequest } from '../../../model/common/common.model';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import _ from 'lodash';
import { Table } from 'primeng/table';
import { getISTDateWithCurrentTime } from '../../../utils/date-utils';

@Component({
  selector: 'app-gst-list-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule],
  templateUrl: './gst-list-lookup.component.html',
  styleUrl: './gst-list-lookup.component.scss'
})
export class GstListLookupComponent implements OnInit {
  @ViewChild('dt1') dt1: Table | undefined;
  constructor(private administratorService: AdministratorService, public ref: DynamicDialogRef, public dialogService: DialogService, private messageService: MessageService,public config: DynamicDialogConfig, ) { }

  gstList: GSTInfo[] = [];
  loading: boolean = false;
  searchKey: any;
  visible: boolean = false;
  warn: boolean = false;
  loader: boolean = false;
  isEdit: boolean = false;
  selectedGST: GSTInfo[] = [];
  gstType: boolean | null = null;
  submitted: boolean = false;
 paginator: boolean = true;
  selectedProduct: any[] = [];

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 1000,
    id: 0
  }

  createGSTForm = new FormGroup({
    // GSTId: new FormControl(0),
    HSNCode: new FormControl('', Validators.required),
    GSTDescription: new FormControl('', Validators.required),
    GSTRate: new FormControl('', Validators.required),
    CreatedBy: new FormControl(''),
    UpdatedBy: new FormControl(''),
    EffectiveFrom: new FormControl(new Date(), Validators.required),
  IsServiceType:  new FormControl<boolean | null>(null, Validators.required), // ✅ boolean
  });
  ngOnInit(): void {
    // Get type from dialog data if passed
    const type: boolean | undefined = this.config?.data?.type;
    if (type === undefined || type === null) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Validation',
        detail: 'Type (Goods/Service) not provided!'
      });
      this.gstList = [];
      return;
    }

    this.gstType = type;
    this.createGSTForm.controls.IsServiceType.setValue(type);
    this.getGSTList(type);

    this.createGSTForm.controls.CreatedBy.setValue(localStorage.getItem('username'));
  }

 getGSTList(type: boolean) {
  this.loader = true;

  this.administratorService.getAllGST(this.pageRequest).subscribe(
    (data: any) => {
      if (data && Array.isArray(data.gst)) {

        this.gstList = data.gst.filter((g: any) => {
          const serviceValue = Number(g.isServiceType
); 
          return type ? serviceValue === 1 : serviceValue === 0;
        });

        this.gstList = this.gstList.map((g: any) => ({
          ...g,
          isServiceType: Number(g.isServiceType) === 1
        }));

        this.selectedGST = [];
      } else {
        this.gstList = [];
      }
      this.loader = false;
    },
    (error: any) => {
      console.error('Error fetching GST list:', error);
      this.gstList = [];
      this.loader = false;
    }
  );
}




  // Select a GST from lookup
  SelectOption(event: any) {
    if (event?.data) {
      this.ref.close(event?.data);
    } else {
      this.ref.close(event);
    }
  }

open() {
  this.visible = true;
  this.isEdit = false;

  this.createGSTForm.reset();

  this.createGSTForm.patchValue({
    CreatedBy: localStorage.getItem('username'),
    IsServiceType: this.gstType   
  });
}

  get formControls() {
  return this.createGSTForm.controls;
}


  createGST() {
  if (this.createGSTForm.invalid) {
    this.warn = true;
       this.submitted = true;

    this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please fill all fields' });
    return;
  }

  this.loader = true;
  const payload = { ...this.createGSTForm.value };

if (payload.EffectiveFrom) {
  const istString = getISTDateWithCurrentTime(payload.EffectiveFrom);
  if (istString) {
    const date = new Date(istString);
    const istOffsetMs = 5.5 * 60 * 60 * 1000; 
    payload.EffectiveFrom = new Date(date.getTime() + istOffsetMs);
  } else {
    payload.EffectiveFrom = null;
  }
} else {
  payload.EffectiveFrom = null;
}

  this.administratorService.createGST(payload).subscribe(
    (data: any) => {
      if (data.success === true) {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: data.message });
        this.visible = false;
        this.loader = false;
         const type = this.createGSTForm.controls.IsServiceType.value;
          if (type !== null) this.getGSTList(type);
          this.createGSTForm.reset();
      } else {
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
        this.loader = false;
      }
    },
    (error: any) => {
      console.log(error);
      this.loader = false;
    }
  );
}
  update() {
    if (this.createGSTForm.invalid) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please fill all fields' });
      return;
    }

    this.loader = true;
    this.administratorService.updateGST(this.createGSTForm.value).subscribe(
      (data: any) => {
        if (data.success) {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: data.message });
          const type = this.createGSTForm.controls.IsServiceType.value;
          if (type !== null) this.getGSTList(type);
          this.createGSTForm.reset();
          this.selectedGST = [];
        } else {
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
        }
        this.loader = false;
      },
      (error: any) => {
        console.error(error);
        this.loader = false;
      }
    );
  }

loadGST(event: any) {

  if (this.searchKey && this.searchKey.trim() !== '') {
    return;
  }

    const type = this.createGSTForm.controls.IsServiceType.value;
    if (type !== null) this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
    if (type !== null) this.getGSTList(type);
}
searchGST() {
  if (!this.searchKey || this.searchKey.trim() === '') {
    if (this.gstType !== null) {
      this.pageRequest.pageIndex = 0;
      this.getGSTList(this.gstType);
    }
    return;
  }

  this.loader = true;

  this.administratorService.autoSearchGST(this.searchKey).subscribe(
    (data: any) => {
      if (Array.isArray(data)) {

        this.gstList = data.filter((g: any) => {
          const serviceValue = Number(g.isServiceType);
          return this.gstType ? serviceValue === 1 : serviceValue === 0;
        });

        if (this.dt1) this.dt1.first = 0;
      } else {
        this.gstList = [];
      }

      this.loader = false;
    },
    (error: any) => {
      console.log(error);
      this.loader = false;
    }
  );
}
}